import { getResolveContentQueryOptions, queryClient } from '@onesource/services';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ContentRouteProvider, useContentRoute } from 'src/features/community-hub/hooks/use-content-route';

/**
 * Lesson layout. Path: /programs/{programSlug}/{moduleSlug}/{lessonSlug}
 * Resolves the full slug chain and extends the content-route context with the
 * lesson id.
 */
export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug')({
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      getResolveContentQueryOptions({
        program: params.programSlug,
        module: params.moduleSlug,
        lesson: params.lessonSlug,
      }),
    ),
  component: LessonRouteWrapper,
});

function LessonRouteWrapper() {
  const { lessonSlug } = Route.useParams();
  const resolved = Route.useLoaderData();
  const parent = useContentRoute();

  return (
    <ContentRouteProvider value={{ ...parent, lessonId: resolved.lesson?.id, lessonSlug }}>
      <Outlet />
    </ContentRouteProvider>
  );
}
